/*!
 * Color mode toggler for Bootstrap's docs (https://getbootstrap.com/)
 * Copyright 2011-2023 The Bootstrap Authors
 * Licensed under the Creative Commons Attribution 3.0 Unported License.
 * https://getbootstrap.com/docs/5.3/customize/color-modes/#javascript
 */

export const getUserColorScheme = () => {
  const d = document.documentElement;
  let theme = d.getAttribute("data-user-theme");
  if (!theme) {
    theme = d.getAttribute("data-bs-theme") || "auto";
    d.setAttribute("data-user-theme", theme);
  }
  return theme;
};

export const getPreferredTheme = () => {
  const colorScheme = getUserColorScheme();

  if (colorScheme && colorScheme !== "auto") {
    return colorScheme;
  }

  return window.matchMedia("(prefers-color-scheme: dark)").matches
    ? "dark"
    : "light";
};

export const setTheme = (theme) => {
  document.documentElement.setAttribute("data-bs-theme", theme);
};

export const init = () => {
  setTheme(getPreferredTheme());

  // Watch for changes to system theme
  window
    .matchMedia("(prefers-color-scheme: dark)")
    .addEventListener("change", () => {
      setTheme(getPreferredTheme());
    });

  // Watch for changes to data-user-theme
  const observer = new MutationObserver(() => {
    setTheme(getPreferredTheme());
  });

  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ["data-user-theme"],
  });
};
